module.exports = __webpack_public_path__ + "static/media/colfactura.87c97801.png";